import React, { useEffect } from 'react';
import './PlayerCardImage.scss'; 
import { getImgTeam } from '../utils/utils.js';
import useLongPress from "../utils/useLongPress.js"
import cara from "../assets/img/cara-default.png";
import estrella from "../assets/img/estrella.png";

const PlayerCardImage = ({ config, index, jugador, updateSelections, longPressActive, openDetails, jornadaSeleccionada, jornadaActual }) => {

    const onLongPress = () => {
        openDetails(index)
    };
    const onClick = () => {
        updateSelections(index)
    }
    const defaultOptions = {
        shouldPreventDefault: true,
        delay: 500,
    };
    const longPressEvent = useLongPress(onLongPress, onClick, defaultOptions);

    const getJugadorPoints = (jugador)=>{
        var puntos = 0
       
        //Jornadas aplazadas ejemplo 30
        console.log(jugador)
        console.log(jornadaSeleccionada)
        if( jornadaSeleccionada == 30){
            puntos = 0
        } else {
            var last = jugador.puntosEquipoJornada.length-1
            puntos += jugador.puntosEquipoJornada[last]
            puntos += jugador.puntosJornada[last]
            puntos += jugador.puntosMvpJornada[last]
        }
        return puntos
    }

    const isStar = (jugador)=>{
        if(jornadaSeleccionada == jornadaActual){
            if(jugador.puntosEquipoJornada[jugador.puntosEquipoJornada.length -1] || jugador.puntosMvpJornada[jugador.puntosMvpJornada.length -1] ){
                return true
            } else{
                return false
            }
        } else if (jornadaSeleccionada < jornadaActual){
            if(jugador.puntosEquipoJornada[jugador.puntosEquipoJornada.length - 2] || jugador.puntosMvpJornada[jugador.puntosMvpJornada.length - 2] ){
                return true
            } else{
                return false
            }
        }
    }

    return (
        <div className="main-container" onClick={()=> updateSelections(index)} {...longPressActive && {...longPressEvent}}>
           <div className={"player-data-container-image"}>
                <div className="player-image">
                    <img src={jugador.foto != "" ? jugador.foto : cara} alt="Cara" className="player-face"/>
                </div>
                <div className="player-name">
                    {jugador.nombre.split(",")[1].trim()}
                </div>
                {jornadaSeleccionada < jornadaActual && <div className="player-points">
                    <div className="points-text">
                        {getJugadorPoints(jugador)}
                    </div>
                </div>}
                 {config.capitan==jugador.nombre &&
                    <div className="capitan-container">
                        <div className="capitan">
                            C
                        </div>
                    </div>}
                {config.sextoHombre==jugador.nombre &&
                    <div className="sextoHombre-container">
                        <div className="sextoHombre">
                            6º
                        </div>
                    </div>}
                <div className="player-team-image">
                    <img src={jugador.escudoClub} alt="Escudo" className="image-team" />
                </div>
                {jugador.puntosJornada != null && isStar(jugador) &&
                <div className="estrella-container">
                    <div className="estrella">
                        <img src={estrella} alt="Estrella" className="image-estrella" />
                    </div>
                </div>}
           </div>
            
        </div>
    );
};

export default PlayerCardImage;